import { useState } from "react";

function useModal() {
    const [showModal, setShowModal] = useState(false);

    function toggleShowModal() {
        setShowModal(!showModal);
    }

    return {
        showModal,
        toggleShowModal,
    }
}

export default useModal;